
export enum PayformDetailCd {
	ACTIVITY = 'Activity',
	HEADER = 'Header',
	NOTE = 'Note',
	SCHEDULE = 'Schedule'}

